import {ReactComponent as TickIcon} from './tick.svg'

function Tick() {
  return <TickIcon />
}

export default Tick
